export default __webpack_public_path__ + "static/media/calendar.5142190b.svg";